export class CTMSMilestonesTable {
    milestones: any[];
    dataTable: any;
    checkedMilestoneIds: Set<number> = new Set();
    studyId: number;
    editable: boolean;

    constructor(allMilestonesJson: any, studyId: number, editable: boolean = true) {
        this.editable = editable;
        $(() => {
            this.studyId = studyId;
            this.milestones = Array.isArray(allMilestonesJson) ? allMilestonesJson : [];
            this.milestones.forEach(m => {
                if (m.StudyMilestoneId && m.StudyMilestoneId !== 0 && m.StudyMilestoneId !== null) {
                    this.checkedMilestoneIds.add(m.Id);
                }
            });
            this.milestones = this.milestones.map(m => ({
                ...m,
                sortKey: (this.checkedMilestoneIds.has(m.Id)
                    ? '0-' + String(m.Order ?? 0).padStart(4, '0')
                    : '1-' + String(m.SortById ?? 0).padStart(4, '0'))
                    //: '1-' + (m.Name ?? '').toLowerCase())
            }));
            this.initializeTable();
        });
    }

    updateSortKeyForMilestone(milestone: any) {
        milestone.sortKey = (this.checkedMilestoneIds.has(milestone.Id)
            ? '0-' + String(milestone.Order ?? 0).padStart(4, '0')
            : '1-' + String(milestone.SortById ?? 0).padStart(4, '0'))
            //: '1-' + (milestone.Name ?? '').toLowerCase());
    }

    reorderCheckedMilestones() {
        // Get all checked milestones, sort by current Order or Name
        const checked = this.milestones
            .filter(m => this.checkedMilestoneIds.has(m.Id))
            .sort((a, b) => {
                if (a.Order != null && b.Order != null) return (a.Order ?? 0) - (b.Order ?? 0);
                return (a.SortById ?? 0) - (b.SortById ?? 0)
                //return (a.Name ?? '').localeCompare(b.Name ?? '');
            });
        // Assign new sequential Order values
        checked.forEach((m, idx) => {
            m.Order = idx + 1;
            this.updateSortKeyForMilestone(m);
        });
    }

    moveCheckedMilestone(id: number, direction: number) {
        // Get all checked milestones sorted by Order
        const checked = this.milestones
            .filter(m => this.checkedMilestoneIds.has(m.Id))
            .sort((a, b) => (a.Order ?? 0) - (b.Order ?? 0));
        const idx = checked.findIndex(m => m.Id === id);
        if (idx === -1) return;
        const swapIdx = idx + direction;
        if (swapIdx < 0 || swapIdx >= checked.length) return;
        // Swap the Order values
        const current = checked[idx];
        const target = checked[swapIdx];
        const tempOrder = current.Order;
        current.Order = target.Order;
        target.Order = tempOrder;
        // Update sortKeys
        this.updateSortKeyForMilestone(current);
        this.updateSortKeyForMilestone(target);
        // Redraw table
        this.dataTable.rows().invalidate().draw(false);
    }

    initializeTable(): void {
        const self = this;
        const columns = [
            { data: "sortKey", title: "sortkey", visible: false, orderable: true },
            self.editable ? {
                data: null,
                orderable: false,
                title: 'Order',
                width: '100px',
                render: function (data, type, row, meta) {
                    if (self.checkedMilestoneIds.has(row.Id)) {
                        let buttons = '';
                        if (row.Order > 1) {
                            buttons += `<button class="ctms-move-up ctms-button mr-1" data-id="${row.Id}" title="Move Up">+</button>`;
                        }
                        if (row.Order < self.checkedMilestoneIds.size) {
                            buttons += `<button class="ctms-move-down ctms-button" data-id="${row.Id}" title="Move Down">-</button>`;
                        }
                        return buttons;
                    }
                    return '';
                }
            } : null,
            { data: "Order", title: "Order", visible: !self.editable, width: '100px' },
            { data: "Name", title: "Name", orderable: false, render: (data, type, row) => self.checkedMilestoneIds.has(row.Id) ? data : `<s>${data}</s>` },
            self.editable ? {
                data: null,
                orderable: false,
                title: '',
                width: '30px',
                render: function (data, type, row, meta) {
                    if (self.checkedMilestoneIds.has(row.Id)) {
                        return `<button class="ctms-milestone-remove ctms-button" data-id="${row.Id}" title="Remove">Remove</button>`;
                    }
                    else {
                        return `<button class="ctms-milestone-add ctms-button" data-id="${row.Id}" title="Add">Add</button>`;
                    }
                }
            } : null,
        ].filter(Boolean);
        this.dataTable = $('#milestones-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: columns,
            order: [[0, 'asc']],
            data: this.milestones
        });

        if (self.editable) {
            this.dataTable.on('draw', function () {
                // Add/Remove button handlers
                $('.ctms-milestone-add').off('click').on('click', function (e) {
                    e.preventDefault();
                    const id = Number($(this).data('id'));
                    self.checkedMilestoneIds.add(id);
                    const milestone = self.milestones.find(m => m.Id === id);
                    if (milestone) {
                        const checkedOrders = self.milestones
                            .filter(m => self.checkedMilestoneIds.has(m.Id) && typeof m.Order === 'number')
                            .map(m => m.Order);
                        const maxOrder = checkedOrders.length ? Math.max(...checkedOrders) : 0;
                        milestone.Order = maxOrder + 1;
                        self.updateSortKeyForMilestone(milestone);
                    }
                    self.reorderCheckedMilestones();
                    self.dataTable.rows().invalidate().draw(false);
                });
                $('.ctms-milestone-remove').off('click').on('click', function (e) {
                    e.preventDefault();
                    const id = Number($(this).data('id'));
                    self.checkedMilestoneIds.delete(id);
                    const milestone = self.milestones.find(m => m.Id === id);
                    if (milestone) {
                        self.updateSortKeyForMilestone(milestone);
                    }
                    self.reorderCheckedMilestones();
                    self.dataTable.rows().invalidate().draw(false);
                });
                // Move up/down handlers
                $('.ctms-move-up').off('click').on('click', function (e) {
                    e.preventDefault();
                    const id = Number($(this).data('id'));
                    self.moveCheckedMilestone(id, -1);
                });
                $('.ctms-move-down').off('click').on('click', function (e) {
                    e.preventDefault();
                    const id = Number($(this).data('id'));
                    self.moveCheckedMilestone(id, 1);
                });
            });
        }
        this.dataTable.draw();

        $('#custom-milestone-dt-search').on('input', function () {
            $('#milestones-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#clear-milestone-dt-search').on('click', function () {
            $('#custom-milestone-dt-search').val('');
            $('#milestones-table').DataTable().search('').draw();
        });
    }
}